// 注册协议，贷款协议
export const GET_CONTRACT = 'GET_CONTRACT'
export const SET_REGISTER_CONTRACT = 'SET_REGISTER_CONTRACT'
export const SET_CONTRACT_STATE = 'SET_CONTRACT_STATE'
export const SET_BANK_STATE = 'SET_BANK_STATE'

// 用户注册
export const USER_REGISTER = 'USER_REGISTER'

// 用户登录
export const USER_LOGIN = 'USER_LOGIN'

// 用户注销
export const USER_LOGOUT = 'USER_LOGOUT'

// 忘记密码
export const FORGET_PASSWORD = 'FORGET_PASSWORD'

export const UPDATE_PASSWORD = 'UPDATE_PASSWORD'



// WEBPACK FOOTER //
// ./src/vuex/types/user/user.js